import { useRef } from 'react';
import { ModalInvestmentList } from './components/modal-investment-list';
import Button from '@core/design-system/button';

type DrawerRefType = {
  openModal: () => void;
  closeModal: () => void;
};

interface SponsoredInvestmentModalProps {
  investmentList: {
    label: string;
    link: string;
  }[];
  buttonProps?: any;
}

export const SponsoredInvestmentModal = ({
  investmentList,
  buttonProps,
}: SponsoredInvestmentModalProps) => {
  const modalInvestmentListRef = useRef<DrawerRefType>(null);

  const toggleModalInvestment = () => {
    const drawer = modalInvestmentListRef?.current;
    if (drawer) {
      drawer.openModal();
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        onClick={toggleModalInvestment}
        sx={{ width: '100%' }}
        {...buttonProps}
      >
        Investir no Fundo
      </Button>

      <ModalInvestmentList
        ref={modalInvestmentListRef}
        investmentList={investmentList}
      />
    </>
  );
};
